import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";
import ListView from "../common/ListView";
import {searchProductHistory} from "./actions";
import {Button} from "antd";
import DateTimeDisplay from "../common/DateTimeDisplay";
import {decodeParams} from "../utils/params";

class ProductHistoryPage extends Component {
  static propTypes = {
    /* state */
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired,
    /* actions */
    searchProductHistory: PropTypes.func.isRequired,
  };

  render() {
    const {
      history, searchProductHistory,
      search: {searching, pagination, filters, sorter, results, searchFilter},
      match: {params},
    } = this.props;
    const {productId} = decodeParams(params);
    const columns = [
      {
        title: 'Created At',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        render: (createdAt) => <DateTimeDisplay dateTime={createdAt}/>,
        width: 165,
      },
      {
        title: 'SKU',
        dataIndex: 'sku',
        key: 'sku',
        sorter: true,
        width: 150,
      },
      {
        title: 'Qty Variance',
        dataIndex: 'quantityVariance',
        key: 'quantityVariance',
        width: 120,
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
    ];
    return (
      <ListView
        title={[
          <Button key="back" icon="arrow-left" onClick={() => history.goBack()} />,
          " History"
        ]}
        searchPlaceholder="Search sku and description"
        loading={searching}
        columns={columns}
        dataSourceProvider={(payload) => searchProductHistory({...payload, filters: {...payload.filters, productId}})}
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        rowKey="eventId"
      />
    );
  }
}

const mapStateToProps = state => ({
  search: state.product.productHistorySearch,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchProductHistory
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(ProductHistoryPage);



// WEBPACK FOOTER //
// ./src/Product/ProductHistoryPage.js